var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "6.3 172.8 1136 447.99999999999994",
    xmlns: "http://www.w3.org/2000/svg",
    width: 2500,
    height: 609,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 215.196,
    x2: 100.359,
    y1: 319.454,
    y2: 434.291
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e3ff"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 297.578,
    x2: 132.007,
    y1: 396.75,
    y2: 396.75
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c00"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 235.969,
    x2: 80.242,
    y1: 412.481,
    y2: 568.208
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c31162"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 116.02,
    x2: 185.559,
    y1: 261.07,
    y2: 330.609
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32a071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    stopColor: "#2da771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15cf74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06e775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f076"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.3 172.8h1136v448H6.3z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M555.6 379.2c-18.7 0-33.9 14.2-33.9 33.8 0 19.5 15.2 33.8 33.9 33.8s33.9-14.3 33.9-33.8-15.2-33.8-33.9-33.8zm0 54.3c-10.2 0-19.1-8.5-19.1-20.5 0-12.2 8.8-20.5 19.1-20.5s19.1 8.3 19.1 20.5c-.1 12-8.9 20.5-19.1 20.5zm90.8-46.7h-.5c-3.3-4-9.7-7.6-17.8-7.6-16.9 0-32.4 14.9-32.4 33.9 0 18.9 15.5 33.7 32.4 33.7 8.1 0 14.5-3.6 17.8-7.7h.5v4.9c0 12.9-6.9 19.8-18 19.8-9.1 0-14.7-6.5-17-12l-12.9 5.4c3.7 9 13.6 20 30 20 17.4 0 32.1-10.2 32.1-35.2v-60.7h-14.1zm-17 46.7c-10.2 0-18.8-8.6-18.8-20.4 0-11.9 8.6-20.6 18.8-20.6 10.1 0 18 8.7 18 20.6s-7.9 20.4-18 20.4zm-147.8-54.3c-18.7 0-33.9 14.2-33.9 33.8 0 19.5 15.2 33.8 33.9 33.8s33.9-14.3 33.9-33.8-15.2-33.8-33.9-33.8zm0 54.3c-10.2 0-19.1-8.5-19.1-20.5 0-12.2 8.8-20.5 19.1-20.5 10.2 0 19.1 8.3 19.1 20.5-.1 12-8.9 20.5-19.1 20.5zm-88.1-44v14.3h34.3c-1 8.1-3.7 14-7.8 18.1-5 5-12.8 10.5-26.5 10.5-21.1 0-37.6-17-37.6-38.1s16.5-38.1 37.6-38.1c11.4 0 19.7 4.5 25.9 10.2l10.1-10.1c-8.6-8.2-20-14.5-36-14.5-28.9 0-53.3 23.6-53.3 52.5s24.3 52.5 53.3 52.5c15.6 0 27.4-5.1 36.6-14.7 9.5-9.5 12.4-22.8 12.4-33.5 0-3.3-.3-6.4-.8-9zm360 11.3c-2.8-7.6-11.4-21.5-28.9-21.5-17.4 0-31.9 13.7-31.9 33.8 0 18.9 14.3 33.8 33.5 33.8 15.5 0 24.5-9.5 28.2-15l-11.5-7.7c-3.8 5.6-9.1 9.3-16.6 9.3s-12.9-3.5-16.4-10.2l45.2-18.7zm-46 11.2c-.4-13.1 10.1-19.7 17.7-19.7 5.9 0 10.9 2.9 12.5 7.2zm-36.8 32.8h14.8v-99.3h-14.8zm152.4-99.3h-35.5v99.3h14.8v-37.6h20.7c16.4 0 32.6-11.9 32.6-30.9 0-18.9-16.2-30.8-32.6-30.8zm.4 47.7h-21.1v-34h21.1c11.1 0 17.4 9.2 17.4 17s-6.3 17-17.4 17zm40.4 51.6h14.8v-99.3h-14.8zm51.2-65.8c-10.7 0-21.9 4.7-26.5 15.2l13.2 5.5c2.8-5.5 8-7.3 13.5-7.3 7.7 0 15.5 4.6 15.6 12.8v1c-2.7-1.5-8.4-3.8-15.5-3.8-14.2 0-28.6 7.8-28.6 22.4 0 13.3 11.6 21.8 24.7 21.8 10 0 15.5-4.5 18.9-9.7h.5v7.7h14.3v-38.1c.1-17.6-13.1-27.5-30.1-27.5zm-1.8 54.5c-4.9 0-11.6-2.4-11.6-8.4 0-7.7 8.4-10.6 15.7-10.6 6.5 0 9.6 1.4 13.5 3.3-1.1 9.2-9 15.7-17.6 15.7zm84.1-52.3l-17 43.1h-.5l-17.6-43.1h-16l26.4 60.2-15.1 33.6h15.5l40.8-93.7h-16.5z",
    opacity: 0.54
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M137.5 311.5c-2 2.1-3.2 5.4-3.2 9.6v151.3c0 4.2 1.2 7.5 3.2 9.6l.5.5 84.8-84.8v-2L138 310.9z",
    fill: "url(#a)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M251 426l-28.2-28.3v-2l28.3-28.3.6.4 33.5 19c9.6 5.4 9.6 14.3 0 19.8l-33.5 19z",
    fill: "url(#b)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M251.7 425.6l-28.9-28.9-85.3 85.3c3.1 3.3 8.4 3.8 14.2.4z",
    fill: "url(#c)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M251.7 367.9l-100-56.8c-5.9-3.3-11.1-2.9-14.2.4l85.3 85.3z",
    fill: "url(#d)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M251 425l-99.3 56.4c-5.6 3.2-10.5 3-13.7.1l-.5.5.5.5c3.2 2.9 8.2 3.1 13.7-.1l100-56.8z",
    opacity: 0.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M137.5 481c-2-2.1-3.2-5.4-3.2-9.6v1c0 4.2 1.2 7.5 3.2 9.6l.5-.5zm147.6-75.4L251 425l.6.6 33.5-19c4.8-2.7 7.2-6.3 7.2-9.9-.4 3.3-2.8 6.4-7.2 8.9z",
    opacity: 0.12
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M151.7 312l133.4 75.8c4.3 2.5 6.8 5.6 7.2 8.9 0-3.6-2.4-7.2-7.2-9.9L151.7 311c-9.6-5.4-17.4-.9-17.4 10v1c0-10.9 7.8-15.4 17.4-10z",
    fill: "#fff",
    opacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStore);
export default __webpack_public_path__ + "static/media/play-store.85720c026fb91e8a4baa164489dbb752.svg";
export { ForwardRef as ReactComponent };